import { format } from 'date-fns';
import sv from 'date-fns/locale/sv';

export function getGlobalPremiereDate() {
    return window.productPremiere && window.productPremiere.date
        ? new Date(window.productPremiere.date * 1000)
        : null;
}

function getTicketWithPremiereDate(tickets) {
    const ticketsWithPremiereDate = tickets.filter(t => t.premiere != null);
    const dates = ticketsWithPremiereDate.map(t => new Date(t.premiere));
    dates.sort((a, b) => {
        return a > b ? -1 : 1;
    });

    return dates.length > 0 ? dates[0] : null;
}

export function isPremiereLocked(tickets = []) {
    const date = getPremiereDate(tickets);
    return date != null && hasPremiereExpired(date);
}

export function hasPremiereExpired(date) {
    return date >= new Date();
}

export function getPremiereDate(tickets = []) {
    const globalPremiereDate = getGlobalPremiereDate();
    const ticketPremiereDate = getTicketWithPremiereDate(tickets);

    // Return the one furthest in the future.
    if (globalPremiereDate && ticketPremiereDate) {
        return globalPremiereDate > ticketPremiereDate
            ? globalPremiereDate
            : ticketPremiereDate;
    }

    return ticketPremiereDate || globalPremiereDate;
}

export function formatPremiereDate(date, dateFormat) {
    return format(date, dateFormat, {locale: sv});
}
